<ul class="nav nav-tabs">
    <li class="nav-item pe-2">
        <a class="nav-link active" aria-current="page">Buscar agencia</a>
    </li>
</ul>
<div class="row">
    <div class="col-12 mt-4">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login">
            <div class="form-control p-0 position-relative">
                <input type="search" formControlName="search" class="w-100 border-secondary" placeholder="Buscar agencia por nombre o por correo electrónico">
                <input type="image" src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon" style="border: 0px; padding: 0px;"  alt="Buscar" />             
            </div>
        </form>
    </div>
</div>
<h4 class="title-bg mt-4">Agencias registradas</h4>

<div class="row mt-4">
    <div *ngFor="let item of listAgencias" class="tour-card">
        <div class="tour-wrapper">
            <ng-template
                *ngIf="item.imagen; then imgRecibida; else imgDefault">
            </ng-template>
            <ng-template #imgRecibida>
                <div class="tour-img">
                    <img src={{item.imagen}} class="img-responsive" alt="">
                </div>
            </ng-template>
            <ng-template #imgDefault>
                <div class="tour-img">
                    <img src="../assets/images/body/tours/5.jpg" class="img-responsive" alt="">
                </div>
            </ng-template>       
            <div class="tour-content">
                <h5 class="mb-3 mt-3 text-center">{{item.nombre_agencia}}</h5>
               
                <a [routerLink]="['/','admin', 'perfil',item.id]" class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Ver info</a>
            </div>
        </div>
    </div>    
</div>
